module.exports = __webpack_public_path__ + "web-icons.078df9f616fd29cb1145.woff2";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Partners-Pipeline/src/assets/fonts/web-icons/web-icons.woff2?v=0.2.3
// module id = ../../../../../src/assets/fonts/web-icons/web-icons.woff2?v=0.2.3
// module chunks = styles